import React, { useState } from "react";
import Head from "next/head";
import FeaturedBlogs from "../../../components/VLSI/featuredBlogs";
import Menu from "../../../components/VLSI/menu";
import MobileMenu from "../../../components/VLSI/mobileMenu";
import Modal from "../../../components/VLSI/modal";
import { redirectTo500 } from "../../../utils/utility";
import ghost from "../../../utils/ghost";
import Footer from "../../../components/VLSI/footer";
import MobileFooter from "../../../components/VLSI/mobileFooter";
import composite from "sharp/lib/composite";

export async function getStaticProps(context) {
  const featuredData = await ghost({
    filter: "tags:blog" + "+tags:vlsi",
    pagination: { limit: 3 },
  });

  if (!featuredData) {
    return redirectTo500();
  }
  return {
    props: {
      featured: featuredData,
    },
    revalidate: 3600,
  };
}

const DesignVerifications = (props) => {
  // modal state
  const [showModal, setShowModal] = useState(false);
  const handleOnClose = () => setShowModal(false);
  return (
    <div>
      <Head>
        <title>DV | Harware Solution in Bangladesh</title>
        <meta
          name="description"
          content="DSi blog space covers the latest technologies and industry trends in eloquent articles penned by our seasoned tech enthusiasts."
        />
      </Head>
      <div className="negative-margin sticky top-0 z-50">
        <header className="hidden lg:block w-full bg-black sticky top-0 z-50">
          <Menu />
        </header>
        <header className="block lg:hidden w-full bg-black sticky top-0 z-50">
          <MobileMenu />
        </header>
      </div>
      {/* page contents container */}
      {/* Hero section */}

      <section className="bg-gray-50">
        <div className="flex flex-col gap-3 lg:gap-6 max-w-screen-xl mx-auto items-center p-7 lg:py-24 lg:px-[30px]">
          <div className="text-3xl sm:text-4xl lg:text-6xl text-gray-900 font-bold sm:font-black text-center max-w-3xl mx-auto">
            Design & Verification
            <p className="text-xl sm:text-4xl lg:text-6xl text-gray-600 font-normal text-center">
              Ensuring Digital Excellence.{" "}
            </p>
          </div>
          <div className="lg:text-xl text-gray-500 lg:leading-relaxed text-center max-w-3xl mx-auto">
            Welcome to our Design & Verification services, where we excel in
            ensuring digital excellence through rigorous validation and
            innovation.
          </div>
          <div className=" mt-2 flex gap-4">
            <button
              onClick={() => {
                setShowModal(true);
              }}
              className=" inline-flex items-center gap-2 px-5 py-3 bg-[#1A56DB] hover:bg-blue-800 text-white  "
            >
              Contact Us <img src="/images/VLSI/ic/arrow-right.svg" />
            </button>
            <a
              href="#second_section_DV"
              className=" inline-flex px-5 py-3 bg-gray-50 hover:bg-gray-100  border border-gray-200 "
            >
              Learn More
            </a>
          </div>
        </div>
      </section>

      {/* modal */}
      <Modal visible={showModal} onClose={handleOnClose} />
      {/* modal ENDS */}

      {/* Hero section ENDS */}

      {/* 2nd section*/}
      <section className="bg-gray-100" id="second_section_DV">
        <div className="flex flex-col lg:gap-6 max-w-screen-xl mx-auto items-center p-7 lg:pt-24 lg:pb-16 lg:px-[30px]">
          <div class=" text-2xl lg:text-4xl text-gray-900 font-bold sm:font-black">
          RTL Design
          </div>
          <div className="lg:text-xl text-gray-500 lg:leading-relaxed text-center max-w-3xl mx-auto">
          Experience enhanced computing power like never before with our cutting-edge RISC-V processor
          </div>
        </div>

        {/* Cards container */}
        <div className="max-w-screen-xl mx-auto p-7 lg:px-[30px] lg:pb-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 lg:gap-8">
            {/* card 1 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="\images\VLSI\verification\performance_boost_icon.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                  Performance Boost
                </span>
                <p className="leading-relaxed text-gray-500">
                  Our microarchitecture redesign delivers faster performance for
                  both floating-point and integer instructions.
                </p>
              </div>
            </div>
            {/* card 2 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="/images/VLSI/verification/customization_icon.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                  Customization
                </span>
                <p className="leading-relaxed text-gray-500">
                  Tailor your processor with custom instructions based on the
                  open-source RISC-V architecture.
                </p>
              </div>
            </div>

            {/* card 3 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="\images\VLSI\verification\efficient_data_control_icon.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                  Efficient Data Control
                </span>
                <p className="leading-relaxed text-gray-500">
                  Our precise data control module ensures seamless data
                  management.
                </p>
              </div>
            </div>

            {/* card 4 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="\images\VLSI\verification\collaborative_excellence_icon.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                  Collaborative Excellence
                </span>
                <p className="leading-relaxed text-gray-500">
                  We work closely with our PD and other teams to guarantee
                  flawless performance and reliability.
                </p>
              </div>
            </div>

            {/* card 5 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="\images\VLSI\verification\optimized_design_icon.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                  Optimized Design
                </span>
                <p className="leading-relaxed text-gray-500">
                  We've optimized the pipeline and fixed RTL bugs for a reliable
                  and efficient processor.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Cards container ENDS */}
      </section>
      {/* 2nd section ENDS */}
      {/* 3rd section */}
      <section className="bg-gray-50">
        <div className=" max-w-screen-xl mx-auto p-7 lg:py-24 lg:px-[30px]">
          <div className="flex flex-col gap-10 lg:gap-20">
            {/* 1 */}
            <div className="flex flex-col-reverse lg:flex-row justify-between items-center gap-6 sm:gap-12 lg:gap-24">
              <div className="lg:basis-1/2">
                <img
                  src="/images/VLSI/verification/Bus Functional Models.png"
                  className="max-w-full"
                />
              </div>
              <div className="lg:basis-1/2">
                <p className="text-2xl lg:text-4xl font-bold">
                  Bus Functional Models
                </p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">Interconnect Validation:</span> We
                  validate interconnect designs to optimize data flow and system
                  performance.
                </p>
              </div>
            </div>
            {/* 2 */}
            <div className="flex flex-col-reverse lg:flex-row-reverse justify-between items-center gap-6 sm:gap-12 lg:gap-24">
              <div className="lg:basis-1/2">
                <img
                  src="/images/VLSI/verification/Design Services.png"
                  className="max-w-full"
                />
              </div>
              <div className="lg:basis-1/2">
                <p className="text-2xl lg:text-4xl font-bold">
                  Design Services
                </p>
                <p className="text-gray-500 mt-3">
                  <span className="font-bold">Register File:</span> Efficient
                  and robust solutions for critical digital systems.
                </p>
                <p className="text-gray-500 mt-3">
                  <span className="font-bold">Interconnect Design:</span>{" "}
                  Seamless communication between system components.
                </p>
                <p className="text-gray-500 mt-3">
                  <span className="font-bold">Memory:</span> Reliable memory
                  design for efficient data access.
                </p>
              </div>
            </div>
            {/* 3 */}
            <div className="flex flex-col-reverse lg:flex-row justify-between items-center gap-6 sm:gap-12 lg:gap-24">
              <div className="lg:basis-1/2">
                <img
                  src="/images/VLSI/verification/RISC-V.png"
                  className="max-w-full"
                />
              </div>
              <div className="lg:basis-1/2">
                <p className="text-2xl lg:text-4xl font-bold">RISC-V</p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">RV32G Core:</span> We High-speed
                  processing for various applications.
                </p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">RV64GV Core:</span> We Precision
                  and performance for complex tasks.
                </p>
              </div>
            </div>
            {/* 4 */}
            <div className="flex flex-col-reverse lg:flex-row-reverse justify-between items-center gap-6 sm:gap-12 lg:gap-24">
              <div className="lg:basis-1/2">
                <img
                  src="/images/VLSI/verification/Testing and Automation.png"
                  className="max-w-full"
                />
              </div>
              <div className="lg:basis-1/2">
                <p className="text-2xl lg:text-4xl font-bold">
                  Testing and Automation
                </p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">Architecture Design:</span>{" "}
                  Customized SoC foundations for specific requirements.
                </p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">Controller Design:</span> Expertly
                  crafted controllers for seamless integration.
                </p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">
                    Platform Level Testing:
                  </span>{" "}
                  Rigorous testing to uncover issues and optimize performance.
                </p>
              </div>
            </div>
            {/* 5 */}
            <div className="flex flex-col-reverse lg:flex-row justify-between items-center gap-6 sm:gap-12 lg:gap-24">
              <div className="lg:basis-1/2">
                <img
                  src="/images/VLSI/verification/Verification IP.png"
                  className="max-w-full"
                />
              </div>
              <div className="lg:basis-1/2">
                <p className="text-2xl lg:text-4xl font-bold">
                  Verification IP
                </p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">APB:</span> Ensuring compatibility
                  and reliability for APB-based designs.
                </p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">AXI4:</span> Thorough validation
                  of AXI designs.
                </p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">AXI4 Stream:</span> Data integrity
                  and reliability for high-speed streaming.
                </p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">I2C, SPI, UART:</span>{" "}
                  Comprehensive verification for communication protocols.
                </p>
              </div>
            </div>
            {/* 6 */}
            <div className="flex flex-col-reverse lg:flex-row-reverse justify-between items-center gap-6 sm:gap-12 lg:gap-24">
              <div className="lg:basis-1/2">
                <img
                  src="/images/VLSI/verification/AXI.png"
                  className="max-w-full"
                />
              </div>
              <div className="lg:basis-1/2">
                <p className="text-2xl lg:text-4xl font-bold">
                AXI
                </p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">Memory Subsystems:</span>{" "}
                  High-performance data storage and retrieval.
                </p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">DMA Controller:</span> Efficient
                  data transfers within your system.
                </p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">Interconnect:</span> Low-latency,
                  high-throughput data connections.
                </p>
                <p className="text-gray-500 mt-3">
                  {" "}
                  <span className="font-bold">Register Interface:</span>{" "}
                  Efficient hardware-software control and monitoring.
                </p>
              </div>
            </div>
          </div>

          {/* tools list ENDS */}
        </div>
      </section>
      {/* 3rd section ENDS */}
      {/* page content container ENDS */}
      {/* blogs starts */}
      {/* featured */}
      <div className="bg-gray-100 w-full py-10 sm:py-20">
        <div className="grid mid-home-column">
          <div className="pb-12 items-center flex flex-col">
            <h2 className="text-black font-headline items-center break-words text-center font-extrabold text-3xl md:text-4xl mb-1">
              Read what we wrote
            </h2>
            <p className="text-center flex font-headline items-center text-base md:text-xl leading-8 text-gray-600">
              Get front-row industry insights
            </p>
          </div>
          <div className="flex justify-center mx-5">
            <FeaturedBlogs
              how={props.featured.posts}
              path="/blogs/"
              title="VIEW DETAILS"
            />
          </div>
        </div>
      </div>

      {/* {showModal && <Modal />} */}
      <div className="hidden md:block md:footer-div absolute z-50 bg-black md:py-24 w-full px-10 xl:px-32">
        <Footer />
      </div>
      <div className="block md:hidden absolute z-50 bg-black py-10 w-full px-7">
        <MobileFooter />
      </div>
    </div>
  );
};

export default DesignVerifications;
